/* KOLI: 購入方法（1回のみ購入／定期便）の切り替え　2026-09-14 新規
   マークアップ＝snippets/koli-purchase-options.liquid／見た目＝koli-custom.css.liquid

   やること2つ：
   ①選ばれた選択肢に応じて hidden の selling_plan を出し入れする
     （「1回のみ購入」のあいだは disabled にして送信対象から外す。value="" を送ると
      チェックアウトが弾くため、空文字ではなく disabled で止める）
   ②商品ページ上部の価格表示を、選んだ価格に差し替える
     （ラジオ側だけ値が変わって上の大きな価格が据え置きだと、どちらが請求額か読めない）

   JSが落ちた場合は hidden が disabled のまま＝「1回のみ購入」として送信される。
   定期便に誤って入るより安全な側に倒れる設計にしてある。 */
(function () {
  var ROOT = '[data-koli-purchase-options]';

  function apply(root) {
    if (!root) return;
    var checked = root.querySelector('.koli-po__radio:checked');
    if (!checked) return;

    // ① selling_plan の出し入れ
    var hidden = root.querySelector('[data-koli-selling-plan]');
    if (hidden) {
      if (checked.value) {
        hidden.value = checked.value;
        hidden.disabled = false;
      } else {
        hidden.value = '';
        hidden.disabled = true;
      }
    }

    // 選択中の枠を強調（CSSは :has を使わず、クラスで確実に効かせる）
    var opts = root.querySelectorAll('.koli-po__opt');
    for (var i = 0; i < opts.length; i++) {
      var input = opts[i].querySelector('.koli-po__radio');
      opts[i].classList.toggle('is-selected', !!(input && input.checked));
    }

    // ② 上部の価格表示を差し替える
    var targetId = root.getAttribute('data-price-target');
    if (!targetId) return;
    var priceEl = document.getElementById(targetId);
    if (!priceEl) return;
    var html = checked.getAttribute('data-price-html');
    if (!html) return;
    var items = priceEl.querySelectorAll('.price-item--regular');
    for (var j = 0; j < items.length; j++) {
      items[j].textContent = html;
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('.koli-po__radio')) apply(t.closest(ROOT));
  });

  function init() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) apply(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
